import { useParams } from "react-router-dom";
import "./teamInfo.less";
import { useQuery } from "@tanstack/react-query";
import { CACHE_TIME_10_MINUTES } from "../../utils/constants";
import { LastResults } from "./components/LastResults/LastResults";
import { Stats } from "./components/Stats/Stats";
import { Col, Grid, Row, Placeholder } from "rsuite";
import { useEffect, useState } from "react";
import { getTeamResults, getTeamStats } from "../../services/team";

const TeamInfo = () => {
  const { id } = useParams();
  const [page, setPage] = useState(1);

  const lastResultsQuery = useQuery(
    ["team", Number(id), "results", page],
    () => getTeamResults(Number(id), page),
    {
      enabled: !!id,
      staleTime: CACHE_TIME_10_MINUTES,
    }
  );

  const query = useQuery(["team", Number(id)], () => getTeamStats(Number(id)), {
    enabled: !!id,
    staleTime: CACHE_TIME_10_MINUTES,
  });

  useEffect(() => {
    setPage(1)
    window.scrollTo(0, 0);
  }, [id]);

  return (
    <div className="page-container">
      {query.isFetching ? (
        <Grid style={{ width: "100% ", marginTop: 32 }}>
          <Row gutter={24}>
            <Col xs={24} md={8} style={{ marginBottom: 16 }}>
              <Placeholder.Graph active height={32} style={{ borderRadius: 8 }} />
            </Col>
          </Row>
        </Grid>
      ) : (
        <div className="team-name">
          <h1>{query.data?.team?.name}</h1>
        </div>
      )}
      <div>
        <Stats isFetching={query.isFetching} teamStats={query.data} />
      </div>
      <LastResults
        teamId={id ? Number(id) : undefined}
        isFetching={lastResultsQuery?.isFetching}
        lastResults={lastResultsQuery.data?.results || []}
        activePage={page}
        total={lastResultsQuery.data?.count || 0}
        onChangePage={setPage}
      />
    </div>
  );
};

export default TeamInfo;
